<template>
  <label class="mb-0">
    <div class="switch switch-left-right">
      <input
        :id="id"
        class="switch-input"
        :name="name"
        type="checkbox"
        :checked="checked"
        @change="onInputChange"
        @click="onClick"
        :disabled="disabled"
      >
        <span
          :class="['switch-label', { disabled: disabled }]"
          :data-on="i18n.yes"
          :data-off="i18n.no"
        ></span>
        <span :class="['switch-handle', { disabled: disabled }]"></span>
    </div>
    <div :class="['toggle-switch__label', { disabled: disabled }]">
      <slot>{{ label }}</slot>
    </div>
  </label>
</template>

  <script>
  export default {
    props: {
      label: {
        type: String,
      },
      value: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      id: {
        type: String,
        required: true,
      },
      name: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        i18n: {
          yes: gettext('Yes'),
          no: gettext('No'),
        },
      };
    },
    computed: {
      checked: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val);
        }
      },
    },
    methods: {
      onInputChange(event) {
        this.checked = event.target.checked;
        this.$emit('change', event);
      },
      onClick(event){
        this.$emit('click',event)
      }
    }
  };
  </script>

<style>
:root {
  --toggle-switch-color-primary: #1F2024;
  --toggle-switch-color-disabled: #71727A;
  --toggle-switch-font-size: 12px;
  --toggle-switch-font-weight: 700;
  --toggle-switch-line-height: normal;
}

label.toggle-switch {
  margin-bottom: 0;
}

.toggle-switch__label {
  color: var(--toggle-switch-color-primary);
  font-size: var(--toggle-switch-font-size);
  font-weight: var(--toggle-switch-font-weight);
  line-height: var(--toggle-switch-line-height);
  cursor: pointer;
}

.toggle-switch__label.disabled {
  color: var(--toggle-switch-color-disabled);
  cursor: not-allowed;
  opacity: .4;
}
</style>
